import { rerenderValidationNew, validateField } from "../utils/validation";

// Constants
const LOGIN_FORM_SELECTOR = "#login-form";

/**
 * Initializes login form validation.
 */
export function initLoginFormValidation() {
    const form = document.querySelector(LOGIN_FORM_SELECTOR);
    if (!form) return;

    form.addEventListener("input", handleFormInput);
    form.addEventListener("change", handleFormInput);
}

/**
 * Validates fields on input or change events.
 *
 * @param {Event} e
 */
function handleFormInput(e) {
    const inputEl = e.target;
    const fieldName = inputEl.name;

    const allErrors = validateField(e.currentTarget, inputEl, getLoginValidationRules(), getLoginWhitelist());
    const fieldErrors = allErrors?.[fieldName] || [];
    rerenderValidationNew(inputEl, fieldErrors);
}

/**
 * Defines validation rules for the login form.
 *
 * @returns {Object}
 */
export function getLoginValidationRules() {
    return {
        email: {
            presence: true,
            email: true
        },
        password: {
            presence: true
        }
    };
}

/**
 * Defines the whitelist of fields to validate.
 *
 * @returns {Object}
 */
export function getLoginWhitelist() {
    return {
        email: true,
        password: true
    };
}
